/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  identity,
  optimisticLockingOf,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import {
  CommunityDto,
  CommunityFilterDto,
  CommunityFinderFilterDto,
  CommunityFinderListItemDto,
} from './community.dto';
import { CommunityMapper } from './community.mapper';

@Injectable()
export class CommunityRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  create(community: CommunityDto): Observable<CommunityDto> {
    return this.httpPost(`${this.bp}/communities`, community, optimisticLockingOf(CommunityMapper));
  }

  update(community: CommunityDto): Observable<CommunityDto> {
    return this.httpPut(`${this.bp}/communities/${community.id}`, community, optimisticLockingOf(CommunityMapper));
  }

  get(id: ID): Observable<CommunityDto> {
    return this.httpGet(`${this.bp}/communities/${id}`, optimisticLockingOf(CommunityMapper));
  }

  findAll({ onlyActive, autocomplete }: CommunityFilterDto): Observable<CommunityDto[]> {
    return this.httpGet(
      `${this.bp}/communities`,
      {
        statuses: onlyActive === true ? [onlyActive] : [true, false],
        autocomplete,
      },
      void 0,
      arrayOf(CommunityMapper));
  }

  findAllForFinderAsDataSource(filter: CommunityFinderFilterDto): SlicedDataSource<CommunityFinderListItemDto> {
    return this.createSlicedDataSourcePost(`${this.bp}/communities/finder`, filter, identity(), arrayOf(identity()));
  }
}
